import originalFetch from 'cross-fetch';
import fetchBuilder from 'fetch-retry';

import type { RequestInitWithRetry } from 'fetch-retry';

import { REMOTECLIENTS_CALLS } from '@shared/constants/newrelic-events/event-names';
import logger from '@shared/utils-frontend/logger';
import { StandardURL } from '@shared/utils-universal/url/StandardURL';

const fetchRetry = fetchBuilder(originalFetch);

const instrumentedFetch = async (
  url: string,
  opts: RequestInitWithRetry<typeof originalFetch> = {},
) => {
  let status;
  const startTime = Date.now();

  // NOTE: Do NOT log the response body here because it might
  // contain PII which must never be logged.

  try {
    const response = await fetchRetry(url, { retries: 0, ...opts });
    ({ status } = response);
    return response;
  } catch (err) {
    status = 504;
    logger.error('Unknown exception on instrumented fetch', { url }, err);
    throw err;
  } finally {
    const duration = Date.now() - startTime;

    logger.event(REMOTECLIENTS_CALLS, {
      url: new StandardURL(url, { removeSearchPath: true }).href,
      duration,
      status,
    });
  }
};

export default instrumentedFetch;
